/**
 * The two things every other part of the level model is written in terms of:
 * an axis-aligned box, and the name of what a surface is made of.
 *
 * A leaf module - it imports nothing from the rest of the level model, so
 * everything else is free to import it.
 */

import type { Vec3 } from '../utils/math';

export type MaterialKey =
  | 'stone'
  | 'water'
  | 'tub'
  | 'hannu'
  | 'tower'
  | 'pirttiFloor'
  | 'pirttiWall'
  | 'pirttiRoof'
  | 'grass'
  | 'gravel'
  | 'fence'
  | 'wood'
  | 'furniture'
  | 'fabric'
  | 'tentCanopy'
  | 'tentWall'
  | 'bucket'
  | 'stain'
  | 'metal'
  | 'brass'
  | 'stove'
  | 'tyre'
  | 'lamp'
  | 'ember'
  | 'car'
  | 'carAlt'
  | 'carEv'
  | 'carGlass'
  | 'windowGlass'
  | 'cable'
  | 'lanFloor'
  | 'lanWall'
  | 'lanRoof'
  | 'barnWall'
  | 'barnRoof'
  | 'faluRed'
  | 'porcelain'
  | 'dirt'
  | 'table'
  | 'sleeper'
  | 'goal'
  | 'screen'
  | 'monitor'
  | 'beer'
  | 'glass'
  | 'spill'
  | 'door'
  | 'foliage';

export interface Box {
  minX: number;
  minY: number;
  minZ: number;
  maxX: number;
  maxY: number;
  maxZ: number;
}

export function boxCenter(box: Box): Vec3 {
  return {
    x: (box.minX + box.maxX) / 2,
    y: (box.minY + box.maxY) / 2,
    z: (box.minZ + box.maxZ) / 2,
  };
}

export function boxSize(box: Box): Vec3 {
  return {
    x: box.maxX - box.minX,
    y: box.maxY - box.minY,
    z: box.maxZ - box.minZ,
  };
}

export function boxContainsXZ(box: Box, x: number, y: number, z: number): boolean {
  return (
    x >= box.minX &&
    x <= box.maxX &&
    z >= box.minZ &&
    z <= box.maxZ &&
    y >= box.minY &&
    y <= box.maxY
  );
}
